export const findLastDeployedVersion = (deployedVersions: string[]): string => {
  const lastDeployedVersion = deployedVersions
    .map((v) => v.replace('v', ''))
    .sort((a, b) => +b - +a)[0];

  return `v${lastDeployedVersion}`;
};
